import { Box } from '@mui/material';
import { useEffect } from 'react';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../app/store/configureStore';
import {
  fetchWaiterRestaurantListAsync,
  waiterRestaurantsSelectors,
} from './waiterRestaurantListSlice';
import { useTranslation } from 'react-i18next';
import ListTitleBox from '../../../app/components/list/ListTitleBox';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import EmptyScreen from '../../../app/components/EmptyScreen';
import RestaurantListItem from '../../../app/components/restaurantList/RestaurantListItem';
import Restaurant from '../../../app/data/models/restaurant';
import { useNavigate } from 'react-router-dom';

const WaiterRestaurantListPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const restaurants = useAppSelector(waiterRestaurantsSelectors.selectAll);
  const { restaurantsLoaded, status } = useAppSelector(
    (state) => state.waiterRestaurants
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (!restaurantsLoaded)
      dispatch(fetchWaiterRestaurantListAsync({ pageNumber: 1, pageSize: 10 }));
  }, [restaurantsLoaded, dispatch]);

  if (!restaurantsLoaded && status.includes('pending'))
    return <LoadingComponent />;

  if (restaurantsLoaded && restaurants.length === 0)
    return (
      <EmptyScreen
        title={t('restaurant.list.title')}
        emptyText={t('restaurant.list.empty')}
      />
    );

  return (
    <>
      <ListTitleBox title={t('restaurant.list.title')} />
      <Box
        sx={{
          width: '100%',
          mb: 2,
          px: { xs: 1, sm: 2 },
        }}
      >
        {restaurants.map((restaurant: Restaurant) => (
          <RestaurantListItem
            key={restaurant.id}
            restaurant={restaurant}
            isEditable={false}
            onClick={() =>
              navigate(`/restaurant-waiter/restaurants/${restaurant.id}/orders`)
            }
            roles={undefined}
            onEdit={() => {}}
          />
        ))}
      </Box>
    </>
  );
};

export default WaiterRestaurantListPage;
